import { Component } from '@angular/core';

@Component({
  selector: 'product-routing',
  template: `
    <article class="component">
      <h1>Produktverwaltung</h1>
      <router-outlet></router-outlet>
    </article>
  `,
  styles: [ 'section table { width: 100%; }' ]
})
export class ProductEntryView {}
